import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import { createIntl } from 'react-intl';

import { customToast } from 'components/widgets/toast/useToast';
import { Config } from 'config/index';
import { localeToLanguageMapper } from 'i18n/index';
import { capitalizeFirstLetter } from 'services/conversion';
import store from 'store/index';
import { setCurrentUser } from 'store/user/action';

import { handleResponseError } from './response';

const TaooServerClient = axios.create({
    baseURL: `${Config.domain}/api/`,
});
const { locale } = store.getState();
const messages = localeToLanguageMapper[locale];
const intl = createIntl({ locale, messages });
const ignoredMessages = ['ACTION_ERROR', 'USER_EXIST', 'USER_SINGLE_SIGN_IN'];

export const generateNewCancelTokenSource = () => axios.CancelToken.source();
export const isRequestCanceled = (error) => axios.isCancel(error);

TaooServerClient.interceptors.response.use(
    (response) => {
        if (
            response &&
            response?.data &&
            'error' in response.data &&
            !isEmpty(response.data.error)
        ) {
            if (ignoredMessages.includes(response.data.message)) {
                return response;
            }

            const errorMessage = response.data?.message || response.data.error;

            const formattedMessage = intl.formatMessage({ id: errorMessage });

            customToast.error(formattedMessage, { toastId: errorMessage });
        }

        return response;
    },
    (error) => {
        if (isRequestCanceled(error)) {
            return;
        }

        if (error.response?.status === 401) {
            store.dispatch(setCurrentUser({}));

            return error;
        }

        const errorCodes = [
            'NOT_ENOUGH_POINTS',
            'USER_ALREADY_CLAIMED_THIS_WEEK',
            'NO_CODES_AVAILABLE',
        ];

        if (error.response?.status === 400) {
            const data = error.response?.data;
            let formattedMessage = null;
            let message = null;

            console.log('error:', error);
            console.log('here:', data);

            if (data?.message && errorCodes.includes(data.message)) {
                formattedMessage = intl.formatMessage({
                    id: data.message,
                });

                console.log('msg:', data.message);
            } else {
                const errorMessage = data?.error || 'RUNTIME_ERROR';

                // const url = error?.response?.config?.url ? error.response.config.url.split('/') : null;
                // const errorFrom = url ? url[url.length - 1] : '';
                // const formattedMessage = intl.formatMessage({ id: errorMessage }, { errorFrom });

                formattedMessage = intl.formatMessage({
                    id: errorMessage,
                });
            }

            message = capitalizeFirstLetter(formattedMessage);
            customToast.error(message, {
                toastId: Date.now(),
            });
        }

        const errorMessage = handleResponseError(error);

        return errorMessage;
    },
);

export default TaooServerClient;
